import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import {
  AuthService,
  POST_LOGIN_PREFERRED_ACCOUNT_ID_KEY,
  POST_LOGIN_REDIRECT_URL_KEY
} from '../services/auth.service';

export const handleLinkGuard: CanActivateFn = async (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const type = route.queryParamMap.get('type');
  const accountUuid = route.queryParamMap.get('accountUuid');
  const invoiceUuid = route.queryParamMap.get('invoiceUuid');
  const address = route.queryParamMap.get('address');
  const reportId = route.queryParamMap.get('reportId');
  const process = route.queryParamMap.get('process');
  const isAuthorized = !!authService.xAuthSession;
  const sourceUrlTree = router.createUrlTree(['/handle-link'], {
    queryParams: route.queryParams
  });

  const savePostLoginContext = () => {
    localStorage.setItem(POST_LOGIN_REDIRECT_URL_KEY, router.serializeUrl(sourceUrlTree));
    if (accountUuid) {
      localStorage.setItem(POST_LOGIN_PREFERRED_ACCOUNT_ID_KEY, accountUuid);
    }
  };

  if (!isAuthorized) {
    savePostLoginContext();
    return router.createUrlTree(['/login']);
  }

  const hasActiveAccount = !!(authService.accountDto()?.uuid ?? authService.xAccountId);
  if (!hasActiveAccount) {
    savePostLoginContext();
    return router.createUrlTree(['/choose-account-login']);
  }

  const targetUrlTree: UrlTree = (() => {
    switch (type) {
      case 'topup':
        return router.createUrlTree(['/balance'], {
          queryParams: { action: 'topup' }
        });

      case 'balanceHistory':
        return router.createUrlTree(['/balance']);

      case 'payment':
        return router.createUrlTree(['/balance'], {
          queryParams: {
            tabIndex: 1,
            action: 'payment',
            invoiceId: invoiceUuid ?? undefined
          }
        });

      case 'purchasingSubscription':
        return router.createUrlTree(['/'], {
          queryParams: {
            action: 'purchasingSubscription',
            address: address ?? undefined
          }
        });

      case 'report':
        return router.createUrlTree(['/monitoring'], {
          queryParams: {
            tabIndex: 1,
            reportId: reportId ?? undefined,
            process: process ?? undefined
          }
        });

      case 'amlScan':
        return router.createUrlTree(['/monitoring'], {
          queryParams: {
            tabIndex: 0,
            amlScanUuid: reportId ?? undefined,
            process: process ?? undefined
          }
        });

      default:
        return router.createUrlTree(['/']);
    }
  })();

  if (accountUuid) {
    authService.lastSelectedAccountId = accountUuid;
  }

  const currentAccountUuid = authService.accountDto()?.uuid ?? authService.xAccountId;
  if (accountUuid && currentAccountUuid !== accountUuid) {
    console.log('targetUrlTree', targetUrlTree);
    return router.createUrlTree(['/approve-change-account'], {
      queryParams: {
        redirectTo: router.serializeUrl(targetUrlTree),
        accountUuid,
      }
    });
  }

  return targetUrlTree;
};
